import { render, staticRenderFns } from "./footertzbs.vue?vue&type=template&id=eaf2d902&scoped=true&"
import script from "./footertzbs.vue?vue&type=script&lang=js&"
export * from "./footertzbs.vue?vue&type=script&lang=js&"
import style0 from "./footertzbs.vue?vue&type=style&index=0&id=eaf2d902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf2d902",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eaf2d902')) {
      api.createRecord('eaf2d902', component.options)
    } else {
      api.reload('eaf2d902', component.options)
    }
    module.hot.accept("./footertzbs.vue?vue&type=template&id=eaf2d902&scoped=true&", function () {
      api.rerender('eaf2d902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/print/components/footertzbs.vue"
export default component.exports